import { Button } from '@mui/material';
import Iconify from 'src/components/iconify';

type Props = {
  onClick: any;
};
export default function ButtonBorrowRegister({ onClick }: Props) {
  return (
    <Button
      fullWidth
      variant="outlined"
      startIcon={<Iconify icon="heroicons:queue-list" />}
      sx={{
        typography: 'caption',
        fontWeight: 500,
        mb: 0.5,
        justifyContent: 'flex-start',
      }}
      onClick={onClick}
      color="primary"
    >
      Đăng kí mượn
    </Button>
  );
}
